class ErrorModalController {
  constructor($scope, $uibModalInstance, $q, message, title, showAdditionalButton, additionalButtonText,
              additionalButtonAction) {
    "ngInject";
    this.$scope                  = $scope;
    this.$uibModalInstance       = $uibModalInstance;
    this.$q                      = $q;
    this._message                = message;
    this._title                  = title;
    this._additionalButtonText   = additionalButtonText;
    this._showAdditionalButton   = showAdditionalButton;
    this._additionalButtonAction = additionalButtonAction;
  }

  confirm() {
    this.$uibModalInstance.close();
  }

  cancel() {
    this.$uibModalInstance.dismiss('cancel');
  }

  // Do whatever the additional button action is and then close the modal
  additionalButtonClick() {
    this.$q.when( this._additionalButtonAction() )
      .then (() => {
        this.$uibModalInstance.close();
      });
  }

  get message() {
    return this._message;
  }

  get title() {
    return this._title;
  }

  get showAdditionalButton() {
    return this._showAdditionalButton;
  }

  get additionalButtonText() {
    return this._additionalButtonText;
  }

}

export default ErrorModalController;
